<div style="display: flex; flex-direction: column; height: 100%; width: 100%;">
  <!-- Multi-cohort view: one chart per cohort -->
  <div *ngIf="isMultiCohort" class="multi-cohort-outer" [class.popup-outer]="popUp">
    <div class="multi-cohort-container" [class.popup-expand]="popUp">
      <div *ngFor="let cohort of cohorts; let i = index" class="cohort-chart-wrapper" [class.popup-expand-wrapper]="popUp">
        <div class="cohort-title" [title]="cohort.title">
          {{ popUp
            ? cohort.title
            : (cohort.title.length > 11 ? (cohort.title | slice:0:11) + '…' : cohort.title) }}
        </div>
        <div
          class="cohort-chart-plot"
          [id]="'chart-container' + id + '-' + i"
          [ngStyle]="popUp ? null : {
            height: containerHeight,
            width: '100%',
            flex: '1 1 auto'
          }"
        ></div>
      </div>
    </div>
    <div *ngIf="isMultiCohort && popUp" [id]="'shared-legend-container' + id" class="popup-shared-legend"></div>
  </div>

  <!-- Single chart view -->
  <div *ngIf="!isMultiCohort"
    [ngStyle]="{
      height: containerHeight,
      width: '100%',
      flex: '1 1 auto'
    }"
  >
    <div
      [id]="'chart-container' + id"
      [ngStyle]="{
        height: chartHeight,
        width: '100%'
      }"
    ></div>
  </div>

  <ng-content select=".insights, [insights]"></ng-content>
</div>
